import {h, Component} from 'preact';
import styles from './style.module.scss';
import {icons} from '../icons';
import {shortenerSerivce} from "../../services/shortener-service";
import {i18nService} from "../../services/i18n-service";
import App from "../app";
import {config} from "../../config";
import {Variant} from "../../models/product";
import {NY_CountryService} from "../../services/country-service";

enum ShareServices {
  Facebook = 'facebook',
  VK = 'vk',
  Pinterest = 'pinterest',
  Mail = 'email',
  Threads = 'threads'
}

interface Props {
  show: boolean
  variant: Variant
}

export default class ShareButtons extends Component<Props, any> {

  render() {
    return (
      <div class={`${styles['share-buttons-container']} ${!this.props.show ? styles['closed'] : ''} 
              ${NY_CountryService.isRestricted(App.countryCode) ? styles['share-buttons-container-with-margin'] : ''}`}>
        {App.countryCode.toUpperCase() === 'BY' || App.countryCode.toUpperCase() === 'RU' ?
        <div class={styles['share-button']} onClick={async () => await this.getShareUrl(ShareServices.VK)}>
          {icons.renderVKontakteIcon()}
        </div> :
        <div class={styles['share-button']} onClick={async () => await this.getShareUrl(ShareServices.Facebook)}>
          {icons.renderFacebookIcon()}
        </div>}
        <div class={styles['share-button']} onClick={async () => await this.getShareUrl(ShareServices.Threads)}>
          {icons.renderThreadsIcon()}
        </div>
        {/*<div class={styles['share-button']}>
          {icons.renderInstagramIcon()}
        </div>*/}
        <div class={styles['share-button']} onClick={async () => await this.getShareUrl(ShareServices.Pinterest)}>
          {icons.renderPinterestIcon()}
        </div>
        <div class={styles['share-button']} onClick={async () => await this.getShareUrl(ShareServices.Mail)}>
          {icons.renderMailIcon()}
        </div>
      </div>
    )
  }

  private async getShareUrl(service: string) {
    const shareText: string = encodeURIComponent(i18nService.translate('product_share_text'));
    const rawUrl = await shortenerSerivce.shorten(`${config.shareBasePath}/product/${this.props.variant.productId}/${this.props.variant.id}?country=${App.countryCode}`);
    const shareUrl = encodeURIComponent(rawUrl.shortUrl);
    switch (service) {
      case 'facebook':
        location.href = `https://facebook.com/sharer/sharer.php?u=${shareUrl}`;
        break;
      case 'vk':
        location.href = `https://vk.com/share.php?url=${shareUrl}`;
        break;
      case 'threads':
        location.href = `https://threads.net/intent/post?text=${shareText}`
        break;
      case 'email':
        location.href = `mailto:?subject=${shareText}&body=${shareUrl}`;
        break;
      case 'pinterest':
        location.href = `https://pinterest.com/pin/create/button/?url=${shareUrl}&amp;media=${shareUrl}&amp;description=${shareText}`;
        break;
      default:
        return '';
    }
  }
}
